import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

export const reportPageView = (): void => {
    const payload = {
        ...getDataFromStores(store.user, store.referrer, store.fromBoost, store.pageType, store.pagePath),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.INTEGRATION_LANDING_PAGE,
    };

    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_VIEW, payload);
};
